<template>
  <section class="shopping-cart-section">
    <div class="container">
      <div class="row">
        <div class="col-xl-8 content-sideBar">
          <div class="shopping-cart-section__wrapper">
            <span class="h1">Cart</span>
            <transition-group
                    name="list"
                    tag="div"
                    class="shopping-cart-section__list"
                    v-if="list_loaded"
            >
              <div
                      class="cartBlock row"
                      v-for="(product, index) in list"
                      v-bind:key="
                                    `${product.id}${product.material.id}`
                                "
              >
                <div class="cartBlock__img col-md-6">
                  <img
                          class="w-100"
                          :src="
                                            product.media.length
                                                ? `/storage/${product.media[0].id}/${product.media[0].file_name}`
                                                : '/assets/img/catalog-1.png'
                                        "
                          alt=""
                  />
                </div>
                <div class="cartBlock__body col-md-6">
                  <a
                          class="cartBlock__title"
                          :href="
                                            `${lang_prefix}/${product.category.parent.slug}/${product.category.slug}/${product.slug}`
                                        "
                  >{{ $lang(product.title) }}</a>
                  <span class="cartBlock__price">{{parseInt(product.material.pivot.price).toLocaleString()}} UAH</span>
                  <div v-html="$lang(product.short_description)"></div>
                  <ul class="product-description">
                    <li class="product-description__item">
                      <p>Material:</p>
                      <span>{{$lang(product.material.title)}}</span>
                    </li>
                  </ul>
                  <button
                          class="cartBlock__delete"
                          @click="remove(index)"
                  >
                    <i></i> <span>Remove</span>
                  </button>
                </div>
              </div>
              <div class="cartBlock" :key="0" v-if="!list.length">Your cart is empty</div>
            </transition-group>
            <div class="shopping-cart-section__mob-container row d-flex d-xl-none">
              <div class="col-lg-6">
                <shop-cart-order-form v-if="!is_ordered"/>
                <div v-else class="shopping-cart-section__ordering shopping-cart-section__ordering-success">
                  <span class="shopping-cart-section__ordering-title shopping-cart-section__column-title">Your order has been placed!</span>
                  <div class="shopping-cart-section__ordering-success-wrapper">
                    <p class="main-text font-weight-bold mb-3 pb-1">
                      Thank you for your order
                    </p>
                    <p class="main-text mb-3 pb-1">
                      Our manager will contact you within
                      10 minutes.
                    </p>
                    <p class="main-text mb-4">
                      If you want to speed things up, call
                      us at
                    </p>
                  </div>
                  <ul class="shopping-cart-section__ordering-num">
                    <li class="shopping-cart-section__ordering-numItem">
                      <a href="tel:+380676200115"><span class="kyivstar-icon"></span>+ 38 (067) 620 01 15</a>
                    </li>
                    <li class="shopping-cart-section__ordering-numItem">
                      <a href="tel:+380506200115"><span class="vodafone-icon"></span>+ 38 (050) 620 01 15</a>
                    </li>
                    <li class="shopping-cart-section__ordering-numItem">
                      <a href="tel:+380936200115"><span class="turkcell-icon"></span>+ 38 (093) 620 01 15</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="shopping-cart-section__orderSteps">
                  <span class="shopping-cart-section__orderSteps-title shopping-cart-section__column-title">How ordering works</span>
                  <ul class="shopping-cart-section__orderSteps-list">
                    <li class="shopping-cart-section__orderSteps-item">
                      <span class="shopping-cart-section__orderSteps-num">1</span>
                      <p class="shopping-cart-section__orderSteps-text">
                        You submit the order form or call us
                      </p>
                    </li>
                    <li class="shopping-cart-section__orderSteps-item">
                      <span class="shopping-cart-section__orderSteps-num">2</span>
                      <p class="shopping-cart-section__orderSteps-text">
                        Our manager contacts you
                      </p>
                    </li>
                    <li class="shopping-cart-section__orderSteps-item">
                      <span class="shopping-cart-section__orderSteps-num">3</span>
                      <p class="shopping-cart-section__orderSteps-text">
                        A specialist evaluates your project
                        for free
                      </p>
                    </li>
                    <li class="shopping-cart-section__orderSteps-item">
                      <span class="shopping-cart-section__orderSteps-num">4</span>
                      <p class="shopping-cart-section__orderSteps-text">
                        We sign a contract and start production of your order
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-4">
          <div
                  class="shopping-cart-section__column d-none d d-xl-flex"
          >
            <div class="sidebar">
              <div class="sidebar__inner">
                <transition
                        name="order"
                        type="fade"
                        mode="out-in"
                >
                  <shop-cart-order-form
                          v-if="!is_ordered"
                  ></shop-cart-order-form>
                  <div v-else
                       class="shopping-cart-section__ordering shopping-cart-section__ordering-success"
                  >
                    <span class="shopping-cart-section__ordering-title shopping-cart-section__column-title">REQUEST RECEIVED!</span>
                    <div class="shopping-cart-section__ordering-success-wrapper">
                      <p class="main-text font-weight-bold mb-3 pb-1">
                        Your request has been received!
                      </p>
                      <p class="main-text mb-3 pb-1">
                        A manager will contact you shortly
                      </p>
                      <p class="main-text mb-4">
                        If you want to speed things up, call us at
                      </p>
                    </div>
                    <ul class="shopping-cart-section__ordering-num">
                      <li class="shopping-cart-section__ordering-numItem">
                        <a href="tel:+380676200115"
                        ><span class="kyivstar-icon"></span> + 38 (067)
                          620 01 15</a
                        >
                      </li>
                      <li class="shopping-cart-section__ordering-numItem">
                        <a href="tel:+380506200115"
                        ><span class="vodafone-icon"></span> + 38 (050)
                          620 01 15</a
                        >
                      </li>
                      <li class="shopping-cart-section__ordering-numItem">
                        <a href="tel:+380936200115"
                        ><span class="turkcell-icon"></span> + 38 (093)
                          620 01 15</a
                        >
                      </li>
                    </ul>
                  </div>
                </transition>
                <div class="shopping-cart-section__orderSteps">
                  <span class="shopping-cart-section__orderSteps-title shopping-cart-section__column-title">How ordering works</span>
                  <ul class="shopping-cart-section__orderSteps-list">
                    <li class="shopping-cart-section__orderSteps-item">
                      <span class="shopping-cart-section__orderSteps-num">1</span>
                      <p class="shopping-cart-section__orderSteps-text">
                        You submit the order form or call us
                      </p>
                    </li>
                    <li class="shopping-cart-section__orderSteps-item">
                      <span class="shopping-cart-section__orderSteps-num">2</span>
                      <p class="shopping-cart-section__orderSteps-text">
                        Our manager contacts you
                      </p>
                    </li>
                    <li class="shopping-cart-section__orderSteps-item">
                      <span class="shopping-cart-section__orderSteps-num">3</span>
                      <p class="shopping-cart-section__orderSteps-text">
                        A specialist evaluates your project for free
                      </p>
                    </li>
                    <li class="shopping-cart-section__orderSteps-item">
                      <span class="shopping-cart-section__orderSteps-num">4</span>
                      <p class="shopping-cart-section__orderSteps-text">
                        We sign a contract and start production of your order
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ShopCartOrderForm from './ShopCartOrderForm'

export default {
  name: 'ShopCardIndex',
  components: { ShopCartOrderForm },
  data: () => ({}),
  computed: {
    ...mapGetters('shop_card', ['list', 'is_ordered', 'list_loaded']),
    lang_prefix () {
      return this.$currentLang === 'ru' ? '/ru' : ''
    },
  },
  methods: {
    ...mapActions('shop_card', ['index', 'store']),
    remove (index) {
      this.list.splice(index, 1)
      this.store(this.list)
    },
  },
  beforeMount () {},
}
</script>

<style scoped>
  .cartBlock {
    transition: transform 0.5s;
  }

  .list-leave-active {
    height: 0;
    margin-bottom: 0;
  }

  .list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */
  {
    opacity: 0;
    transform: translateY(-20px);
  }

  .order-enter-active, .order-leave-active {
    transition: opacity .3s ease;
  }

  .order-enter, .order-leave-to
    /* .component-fade-leave-active до версии 2.1.8 */
  {
    opacity: 0;
  }
</style>
